import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { clearPermissionCache } from '@/contexts/PermissionContext'
import { token, currentUser, BASE_URL } from '@/lib/api'
import { queryClient } from '@/lib/queryClient'

const IDLE_MS = 5 * 60 * 1000

const EVENTS = ['mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll', 'click'] as const

export function useIdleLogout() {
  const navigate = useNavigate()
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    const logout = async () => {
      try {
        await fetch(`${BASE_URL}/api/v1/auth/logout`, {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
        })
      } catch { /* best-effort */ }
      token.clear()
      currentUser.clear()
      clearPermissionCache()
      queryClient.clear()
      navigate('/login', { replace: true, state: { idle: true } })
    }

    const reset = () => {
      if (timer.current) clearTimeout(timer.current)
      timer.current = setTimeout(logout, IDLE_MS)
    }

    EVENTS.forEach((e) => window.addEventListener(e, reset, { passive: true }))
    reset()

    return () => {
      if (timer.current) clearTimeout(timer.current)
      EVENTS.forEach((e) => window.removeEventListener(e, reset))
    }
  }, [navigate])
}
